import { render, staticRenderFns } from "./PersonalDocument.vue?vue&type=template&id=20658352&scoped=true&"
import script from "./PersonalDocument.vue?vue&type=script&lang=ts&"
export * from "./PersonalDocument.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDocument.vue?vue&type=style&index=0&id=20658352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20658352",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
